var $ = require('jquery');

/**
 * NextPageLoader - dynamically loads next page items on button click
 * element @param jquery selector - context element
 * btn @param jquery selector - button
 */

var NextPageLoader = module.exports = function(element, btn) {
    this.elementSelector = element;
    this.element = $(element);
    this.btnSelector = btn;
    this.btn = this.element.find(btn);
    this.nextUrl = this.btn.attr('href');

    this.htmlLoader = null;
    this.ajaxLoaderImg = '/img/ajax-loader.gif';
    this.htmlLoaderCreated = false;

    this.newsUrls = ['/cs/o-nas/novinky', '/en/about-us/news'];
    this.newsPaginationUrls = ['/cs/o-nas/novinky/strana-', '/en/about-us/news/page-'];
};

NextPageLoader.prototype = {

    init: function() {

        this._addListeners();
        this._loadPrevPages();
    },

    _addListeners: function() {
        this.btn.on('click', $.proxy(function(e) {
            this._ajaxCall(this.nextUrl, $.proxy(this._appendData, this));
            e.preventDefault();
        }, this));
    },

    _ajaxCall: function(url, callback) {
        this.xhr = $.ajax({
            url: url,
            beforeSend: $.proxy(function() {
                this._showAjaxLoader();
            }, this),
            complete: $.proxy(function() {
                this._hideAjaxLoader();
            }, this),
            success: $.proxy(function(data) {
                delete this.xhr;
                callback(data);
            }, this),
            error: $.proxy(function(xhr, status, error) {
                location.href = this.nextUrl;
            }, this)
        });
    },

    _appendData: function(data) {
        var result = $(data).find(this.elementSelector);
        var articles = result.children('[data-load=content]');
        this._historyPush(this.nextUrl);
        this.nextUrl = result.find(this.btnSelector).attr('href');
        this.btn.parent().before(articles);
        if (this.nextUrl !== undefined) {
            this.btn.attr('href', this.nextUrl);
        } else {
            this.btn.remove();
        }

    },

    _loadPrevPages: function() {
        var pagination = -1;
        var paginationUrl = '';
        var index = 0;
        $.each(this.newsPaginationUrls, function(i, url) {
            pagination =  location.href.indexOf(url);
            if (pagination > -1) {
                paginationUrl = url;
                index = i;
                return false;
            }
        });

        if (pagination > -1) {
            var page =  parseInt(location.href.substring(pagination + paginationUrl.length));
            var url;
            for (page; page > 0; page--) {
                if (page > 1) {
                    url = paginationUrl + (page - 1);
                } else {
                    url = this.newsUrls[index];
                }
                this._ajaxCall(url, $.proxy(this._prependData, this));
            }
        }
    },

    _prependData: function(data) {
        var result = $(data).find(this.elementSelector);
        var articles = result.children('[data-load=content]');

        this.element.prepend(articles);
    },

    _historyPush: function(url) {
        if (window.history && history.pushState) {
            history.pushState(null, null, url);
        }
    },

    _showAjaxLoader: function() {
        if (this.htmlLoaderCreated == false) {
            this.htmlLoader = $('<div class="preloader" style="position: absolute; z-index: 1000000; left: 50%; margin-left: -16px; bottom: -40px; background: url('+ this.ajaxLoaderImg +'); width: 32px; height: 32px"></div>');
            this.element.append(this.htmlLoader);
            this.htmlLoaderCreated = true;
        }
        this.htmlLoader.show();
    },

    _hideAjaxLoader: function() {
        this.htmlLoader.hide();
    }

};


// WEBPACK FOOTER //
// ./fe/web-gmeinder/src/js/web/nextPageLoader.js